import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailer_notifications-p0_nudge-view';

/**
 * Records view on p0 notification nudge
 */
export function trackRetailerNotificationsP0NudgeView(
  Notification_Type_string: string,
  Message_string2: string,
  Notification_Identifier_string3: string = '',
  Run_Token_string4: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      Notification_Type_string,
      Message_string2,
      Notification_Identifier_string3,
      Run_Token_string4,
    },
  });
}
